import { Col, Label, Row } from "reactstrap";
import ModalComponent from "../common/Modal/modal";
import { Form } from "react-router-dom";
import { FIELD_TYPES, FieldItem } from "../../widgets/fields";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import { CustomButton } from "../../widgets";
import { useEffect, useState } from "react";
import { convertToIST } from "../../utils/ConvertUTCToLocale";
import { ColumnFilter } from "../../widgets/table/columnfilter";
import { useDispatch } from "react-redux";
import { setLoading } from "../../store/slices/auth";
import { getFilteredFormRecords, postSearchIndex } from "./apiController";
import moment from "moment";

const ExistingDataModal = (props) => {
    const [values, fields, handleChange, { validateValues, reset, updateValue, resetValue, updateError }] = useFieldItem({}, {}, { onValueChange });
    const { existingData, getExistingData, searchIndexUidData } = props;
    const [tableData, setTableData] = useState<any>([]);
    const [filterData, setFilterData] = useState<any>([]);
    const [searchData, setsearchData] = useState<any>({});
    const [responseData, setresponseData] = useState<any>([]);

    const dispatch = useDispatch();

    function onValueChange(name, value, values, fieldValues = null) {
        return [{
            ...values,
            [name]: value,
        }]
    }

    useEffect(() => {
        let tableData: any = [];
        existingData && existingData.map((data, index) => {
            const objectWithLargestFields = data.record_info.reduce((max, current) =>
                current.fields.length > max.fields.length ? current : max, data.record_info[0]);

            const sortedData = data.record_info.sort((a, b) => b.fields.length - a.fields.length);

            let tabObj = {
                formName: data.form_name,
                formId: data.form_id, // Assuming form has an id
                headers: objectWithLargestFields,
                bodydata: sortedData,
                formIndex: index
            }
            tableData.push(tabObj)
        })
        setTableData(tableData)
    }, [existingData])

    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;

    /**
     * Get search text for filters
     */
    const getSearchText = (data, searchvalue) => {
        let SearchArray: any = [];
        SearchArray = filterData.filter(
            item => item.field_id != data.data.id && item.search_value != ""
        );
        let searchData: any = {};

        // Check if it's a date range input
        const isDateRange =
            typeof searchvalue === "object" && searchvalue.start !== undefined;

        // TRUE only if BOTH start and end are present
        const bothDatesPresent =
            isDateRange && searchvalue.start && searchvalue.end;

        // For strings: valid only if text exists
        const hasText = typeof searchvalue === "string" && searchvalue.length > 0;

        if (bothDatesPresent || hasText) {
            // IF BLOCK → only when both dates OR valid text

            let Obj = {
                field_id: data.data.id,
                search_value: searchvalue,
                field_type: data.data.field_type,
                is_field: true,
                is_range: isDateRange,
                start_created_at: isDateRange
                    ? searchvalue.start
                        ? new Date(String(searchvalue.start))
                        : null
                    : null,
                end_created_at: isDateRange
                    ? searchvalue.end
                        ? new Date(String(searchvalue.end))
                        : null
                    : null,
                time_zone: tz
            };

            SearchArray.push(Obj);
            setFilterData(SearchArray);

            searchData = {
                search_data: SearchArray
            };

        } else if (isDateRange && (searchvalue.start || searchvalue.end)) {
            // ELSE IF BLOCK → one date present
            let Obj = {
                field_id: data.data.id,
                search_value: searchvalue.start || searchvalue.end,
                field_type: data.data.field_type,
                // is_field: true,
                // is_range: false,
                time_zone: tz
            }
            SearchArray.push(Obj);
            setFilterData(SearchArray);

            searchData = {
                search_data: SearchArray
            };

        } else {
            // ELSE BLOCK → no dates
            searchData = {
                search_data: SearchArray
            };
            setFilterData(SearchArray);
        }

        setsearchData(searchData);
    };

    /**
     * Apply filter
     */
    const applyFilter = (type, formIndex) => {
        if (type == "text") {
            getFilteredData(searchData, formIndex)
        }
    }

    /**
     * Get filtered records from API
     */
    const getFilteredData = async (data, formIndex) => {
        try {
            dispatch(setLoading(true));

            const currentForm = tableData[formIndex];
            const formId = currentForm?.formId;
            const topicId = props.topicId || null;
            const searchDataObj = [...data.search_data, ...searchIndexUidData];

            const response = await postSearchIndex(
                topicId,
                formId,
                searchDataObj,
                true
            );

            const matchingForm = response?.data?.find(form => form.form_id === formId);
            const records = matchingForm?.record_info || [];

            setTableData(prev => {
                const updated = [...prev];
                updated[formIndex] = {
                    ...updated[formIndex],
                    bodydata: records
                };
                console.log('Updated tableData:', updated[formIndex]);
                return updated;
            });

            setresponseData(records);
            dispatch(setLoading(false));

        } catch (e) {
            console.error("Filter error:", e);
            dispatch(setLoading(false));
        }
    };


    /**
     * on submit function
     */
    const onSubmit = () => {
        if (!values.form || values.form == "") {
            return;
        }
        let id = values.form.split("_")
        let form = existingData[id[0]].record_info[id[1]]
        getExistingData(form)
        props.isClose()
    }

    return (
        <ModalComponent
            width={"80%"}
            isOpen={true}
            onClose={() => props.isClose()}
            header="Select Existing Data"
            centered={true}
            customClass='existing-modal'
            body={
                <div className="existing-data-modal">
                    {
                        tableData && tableData?.map((data, index) => {
                            return (data?.headers && <div key={index} className="existing-data-item">
                                <div className="existing-data-form">
                                    <div style={{ color: '#333', whiteSpace: 'nowrap', fontWeight: '600', fontSize: '16px' }}><Label>Form Name:</Label></div>
                                    <div style={{ fontSize: '20px' }}> {data.formName}</div>
                                </div>

                                <div className="field-data">
                                    <div className="field-item" key={index}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th id="sel" className="theadval">#</th>
                                                    {data?.headers && data?.headers?.fields?.map((item, i) => (
                                                        <th key={i} className="theadval" title={item.field_name}>
                                                            <div style={{ marginBottom: '8px' }}>
                                                                {item.field_name}
                                                            </div>
                                                            <ColumnFilter
                                                                getSearchText={getSearchText}
                                                                applyFilter={(type) => applyFilter(type, data.formIndex)}
                                                                column={{
                                                                    field_name: item.field_name,
                                                                    field_type: item.field_type,
                                                                    id: item.id || item.field_name,
                                                                    data: item
                                                                }}
                                                                previousData={filterData}
                                                            />
                                                        </th>
                                                    ))}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data?.bodydata && data?.bodydata?.length > 0 ? (
                                                        data.bodydata.map((itemd, ind) => (
                                                            <tr key={ind}>
                                                                <td id="seld">
                                                                    <FieldItem
                                                                        name={"form"}
                                                                        value={values.form}
                                                                        values={[{ label: "", value: data.formIndex + "_" + ind }]}
                                                                        type={FIELD_TYPES.RADIO_BUTTON}
                                                                        onChange={(...e) => handleChange("form", ...e)}
                                                                    />
                                                                </td>
                                                                {
                                                                    // Map over HEADERS instead of the record's fields
                                                                    data?.headers?.fields?.map((headerField, tabindex) => {
                                                                        // Find the matching field in this record by field_id
                                                                        const matchingField = itemd?.fields?.find(
                                                                            field => field.id === headerField.id ||
                                                                                field.field_id === headerField.id ||
                                                                                field.field_name === headerField.field_name
                                                                        );

                                                                        return (
                                                                            <td key={tabindex}>
                                                                                {matchingField ? (
                                                                                    (() => {
                                                                                        if (matchingField?.field_type === "dateField") {
                                                                                            return matchingField?.field_selected_value?.length > 0
                                                                                                ? convertToIST(matchingField.field_selected_value)
                                                                                                : "-";
                                                                                        } else if (matchingField?.field_type === "checkBox") {
                                                                                            return matchingField.field_selected_value && Array.isArray(matchingField.field_selected_value)
                                                                                                ? matchingField.field_selected_value.map((itm, idx) => (
                                                                                                    <span key={`${tabindex}-${idx}`}>
                                                                                                        {typeof itm === 'object' ? (itm.value || itm.label || JSON.stringify(itm)) : itm}
                                                                                                        {idx < matchingField.field_selected_value.length - 1 ? ', ' : ''}
                                                                                                    </span>
                                                                                                ))
                                                                                                : "-";
                                                                                        } else {
                                                                                            const value = matchingField?.field_selected_value;
                                                                                            if (value === null || value === undefined) {
                                                                                                return "-";
                                                                                            } else if (typeof value === 'object') {
                                                                                                return value.value || value.label || value.name || JSON.stringify(value);
                                                                                            } else {
                                                                                                return String(value);
                                                                                            }
                                                                                        }
                                                                                    })()
                                                                                ) : (
                                                                                    "-" // Show dash if field is missing in this record
                                                                                )}
                                                                            </td>
                                                                        );
                                                                    })
                                                                }
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={data?.headers?.fields?.length + 1} style={{ textAlign: 'center', padding: '20px' }}>
                                                                No records found
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            )
                        })
                    }
                </div>
            }
            footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <CustomButton type="primary-alt" className="mr-2" onClick={props.isClose} text="Cancel" />
                    <CustomButton type="primary" className="mr-2" onClick={() => onSubmit()} text="Continue" />
                </div>
            }
        />
    )
}
export default ExistingDataModal;